import React from 'react';
import { Route } from 'react-router-dom';
import Departments from '../pages/departments/Departments';
import DepartmentsArchive from '../pages/departments/DepartmentsArchive';
import CreateDepartment from '../pages/departments/CreateDepartment';
import EditDepartment from '../pages/departments/EditDepartment';
import PermissionGuard from '../components/global/PermissionGuard';

const departmentsRoutes = (
    <>
        <Route
            path="/departments"
            element={
                <PermissionGuard permission="departments_list">
                    <Departments />
                </PermissionGuard>
            }
        />
        <Route
            path="/departments/archive"
            element={
                <PermissionGuard permission="departments_archive_list">
                    <DepartmentsArchive />
                </PermissionGuard>
            }
        />
        <Route
            path="/departments/create"
            element={
                <PermissionGuard permission="departments_create">
                    <CreateDepartment />
                </PermissionGuard>
            }
        />
        <Route
            path="/departments/:id/edit"
            element={
                <PermissionGuard permission="departments_edit">
                    <EditDepartment />
                </PermissionGuard>
            }
        />
    </>
);

export default departmentsRoutes;
